import { InputSize, Select, SelectType, type SelectItem } from "./ring.ts";

export interface SimpleOption {
  value: string;
  label: string;
}

/** String-valued single select on Ring's Select (button-shaped): the replacement for native <select> in forms and tables. */
export function SimpleSelect({ value, options, onChange, placeholder = "—", disabled = false, full = false, className }: { value: string; options: SimpleOption[]; onChange: (value: string) => void; placeholder?: string; disabled?: boolean; full?: boolean; className?: string }) {
  const data: SelectItem[] = options.map((o) => ({ key: o.value, label: o.label }));
  const selected = data.find((d) => d.key === value) ?? null;
  return (
    <Select
      type={SelectType.BUTTON}
      multiple={false}
      filter={options.length > 8}
      data={data}
      selected={selected}
      label={placeholder}
      disabled={disabled}
      {...(full ? { size: InputSize.FULL } : {})}
      {...(className ? { className } : {})}
      onChange={(item: SelectItem | null) => onChange(item === null ? "" : String(item.key))}
    />
  );
}
